import Transform from '@ember-data/serializer/transform';

export default class ElevationTransform extends Transform {
  serialize() {
    console.log('ElevationTransform', ...arguments);
  }
  deserialize(serialized) {
    let result = parseFloat(serialized);
    if (isNaN(+serialized) || isNaN(result)) {
      return serialized;
    }
    result = (~~result).toLocaleString() + ' ft';
    return result;
  }
}
